"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.shouldCancelAutoPlayOnHover = exports.shouldCancelAutoPlayOnAction = exports.getItemIndexForDotNavigation = exports.checkIsTheLastDotIndex = exports.getDotsNavigationLength = exports.hasDotForEachSlide = exports.isStrategy = exports.shouldDisableButtons = exports.shouldDisableDots = exports.shouldDisableControls = void 0;

var types_1 = require("../types");

function shouldDisableControls(t, o) {
  var t = (t || {}).controlsStrategy,
      o = o || {},
      e = o.itemsInSlide,
      s = o.itemsCount,
      o = o.autoWidth;
  if (exports.isStrategy(t, types_1.ControlsStrategy.RESPONSIVE)) return !o && e === s;
}

function shouldDisableDots(t, o) {
  return t.disableDotsControls || shouldDisableControls(t, o);
}

function shouldDisableButtons(t, o) {
  return t.disableButtonsControls || !t.infinite && shouldDisableControls(t, o);
}

exports.shouldDisableControls = shouldDisableControls, exports.shouldDisableDots = shouldDisableDots, exports.shouldDisableButtons = shouldDisableButtons, exports.isStrategy = function (t, o) {
  return t && t.includes(o);
}, exports.hasDotForEachSlide = function (t, o) {
  return t || exports.isStrategy(o, types_1.ControlsStrategy.ALTERNATE);
}, exports.getDotsNavigationLength = function (t, o, e) {
  return void 0 === t && (t = 0), void 0 === o && (o = 1), e ? t : 0 !== Number(o) && Math.ceil(t / o) || 0;
}, exports.checkIsTheLastDotIndex = function (t, o, e) {
  return !o && t === e - 1;
}, exports.getItemIndexForDotNavigation = function (t, o, e, s) {
  return (o ? e - s : t * s) || 0;
}, exports.shouldCancelAutoPlayOnAction = function (t) {
  return (t = void 0 === t ? "" : t) === types_1.AutoPlayStrategy.ACTION || t === types_1.AutoPlayStrategy.ALL;
}, exports.shouldCancelAutoPlayOnHover = function (t) {
  return (t = void 0 === t ? "" : t) === types_1.AutoPlayStrategy.DEFAULT || t === types_1.AutoPlayStrategy.ALL;
};